export default "__VITE_ASSET__DVnUON4$__"